import { render } from "./BoxingResults.vue?vue&type=template&id=444ef0d8&scoped=true"
import script from "./BoxingResults.vue?vue&type=script&lang=js"
export * from "./BoxingResults.vue?vue&type=script&lang=js"

import "./BoxingResults.vue?vue&type=style&index=0&id=444ef0d8&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444ef0d8"]])

export default __exports__